import axios from "axios";
import firebase from 'firebase/app';
import 'firebase/auth';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 60000,
});

const config = async () => {
    return {
        headers: {
            Authorization: await firebase.auth().currentUser?.getIdToken(),
        }
    }
}

export const register = async (email, name) => {
    await api.post('/register', {
        email: email,
        name: name,
    }, await config());
}

export const createWallet = async () => {
    await api.post('/wallet',
        null,
        await config());
}

export const updateProfile = async (name) => {
    await api.post('/profile', {
        name: name,
    }, await config());
}

export const claim = async () => {
    await api.post('/claim',
        null,
        await config());
}

export const withdraw = async (address, amount) => {
    await api.post('/withdraw', {
        address: address,
        amount: amount
    }, await config());
}

export const check = async (tableId) => {
    await api.post('/check', {
        tableId: tableId,
    }, await config());
}

export const fold = async (tableId) => {
    await api.post('/fold', {
        tableId: tableId,
    }, await config());
}

export const call = async (tableId) => {
    await api.post('/call', {
        tableId: tableId,
    }, await config());
}

export const raise = async (tableId, money) => {
    await api.post('/raise', {
        tableId: tableId,
        money: money,
    }, await config());
}

export const sit = async (tableId, seatId) => {
    await api.post('/sit', {
        tableId: tableId,
        seatId: seatId,
    }, await config());
}

export const leave = async (tableId, seatId) => {
    await api.post('/leave', {
        tableId: tableId,
        seatId: seatId,
    }, await config());
}

export const kick = async (tableId, seatId) => {
    await api.post('/kick', {
        tableId: tableId,
        seatId: seatId,
    }, await config());
}

export const sendMessage = async (message, tableId) => {
    await api.post('/messages', {
        message: message,
        tableId: tableId
    }, await config());
}

export const sitOut = async (tableId) => {
    await api.post('/sitOut', {
        tableId: tableId,
    }, await config());
}

export const sitIn = async (tableId) => {
    await api.post('/sitIn', {
        tableId: tableId,
    }, await config());
}
